import { CUSTOM_DYNAMIC_BULLETS } from './constants'

function getBulletSize(swiper) {
  const bullets = swiper.pagination?.bullets || []
  const firstBullet = bullets[0]
  if (!firstBullet) {
    return 0
  }

  if (bullets.length > 1) {
    return bullets[1].offsetLeft - bullets[0].offsetLeft
  }

  const styles = window.getComputedStyle(firstBullet)
  const marginLeft = Number.parseFloat(styles.marginLeft) || 0
  const marginRight = Number.parseFloat(styles.marginRight) || 0
  return firstBullet.offsetWidth + marginLeft + marginRight
}

function setVisibleRangeData(swiper, { translateX: forcedTranslateX } = {}) {
  const paginationEl = swiper.pagination?.el
  const wrapperEl = paginationEl?.parentElement
  if (!paginationEl || !wrapperEl) {
    return
  }

  const step = getBulletSize(swiper)
  if (!step) {
    return
  }

  const transform = paginationEl.style.transform || ''
  const match = transform.match(/translate3d\(([-\d.]+)px,\s*0,\s*0\)/)
  const parsedTranslateX = match ? Number.parseFloat(match[1]) : 0
  const translateX = Number.isFinite(forcedTranslateX) ? forcedTranslateX : parsedTranslateX
  const visibleStart = Math.max(0, Math.round(Math.abs(translateX) / step))
  const visibleEnd = visibleStart + CUSTOM_DYNAMIC_BULLETS.visibleBullets - 1

  wrapperEl.dataset.visibleStart = `${visibleStart}`
  wrapperEl.dataset.visibleEnd = `${visibleEnd}`
}

function clearVisibleRangeData(swiper) {
  const paginationEl = swiper.pagination?.el
  const wrapperEl = paginationEl?.parentElement
  if (!paginationEl || !wrapperEl) {
    return
  }

  delete wrapperEl.dataset.visibleStart
  delete wrapperEl.dataset.visibleEnd
}

function enableCustomPagination(swiper) {
  const el = swiper.pagination?.el
  const wrapperEl = el?.parentElement
  if (!el || !wrapperEl) return

  const step = getBulletSize(swiper)
  if (!step) return

  wrapperEl.style.maxWidth = `${step * CUSTOM_DYNAMIC_BULLETS.visibleBullets}px`
  setVisibleRangeData(swiper)
}

function disableCustomPagination(swiper) {
  const el = swiper.pagination?.el
  const wrapperEl = el?.parentElement
  if (!el || !wrapperEl) return

  wrapperEl.style.maxWidth = ''
  el.style.transform = ''
  clearVisibleRangeData(swiper)
}

export function initPaginationVisibility(swiper) {
  const el = swiper.pagination?.el
  const count = swiper.pagination?.bullets?.length ?? 0

  if (!el) return

  if (count <= CUSTOM_DYNAMIC_BULLETS.visibleBullets) {
    disableCustomPagination(swiper)
  } else {
    enableCustomPagination(swiper)
  }
}

export function updatePaginationVisibility(swiper) {
  const paginationEl = swiper.pagination?.el
  const wrapperEl = paginationEl?.parentElement
  const bullets = swiper.pagination?.bullets || []
  if (!paginationEl || !wrapperEl || !bullets.length) return

  const step = getBulletSize(swiper)
  if (!step) return

  const activeIndex = bullets.findIndex((bullet) => (
    bullet.classList.contains('swiper-pagination-bullet-active')
  ))
  if (activeIndex < 0) return

  const visibleStart = Number.parseInt(wrapperEl.dataset.visibleStart || '0', 10)
  const visibleEndRaw = Number.parseInt(wrapperEl.dataset.visibleEnd || '-1', 10)
  const lastIndex = bullets.length - 1
  const visibleEnd = Math.min(visibleEndRaw, lastIndex)
  const maxStart = Math.max(0, bullets.length - CUSTOM_DYNAMIC_BULLETS.visibleBullets)

  let nextStart = visibleStart
  if (activeIndex === visibleEnd && visibleStart < maxStart) {
    nextStart = Math.min(visibleStart + 1, maxStart)
  } else if (activeIndex === visibleStart && visibleStart > 0) {
    nextStart = Math.max(visibleStart - 1, 0)
  } else {
    return
  }

  const translateX = -(nextStart * step)
  paginationEl.style.transform = `translate3d(${translateX}px, 0, 0)`
  setVisibleRangeData(swiper, { translateX })
}

export function onActiveBulletChange(swiper) {
  const bullets = swiper.pagination?.bullets || []
  const wrapperEl = swiper.pagination?.el?.parentElement
  if (!wrapperEl || !bullets.length) return

  const activeIndex = bullets.findIndex((bullet) => (
    bullet.classList.contains('swiper-pagination-bullet-active')
  ))
  if (activeIndex < 0) return

  const visibleStart = Number.parseInt(wrapperEl.dataset.visibleStart || '0', 10)
  const visibleEndRaw = Number.parseInt(wrapperEl.dataset.visibleEnd || '-1', 10)
  const lastIndex = bullets.length - 1
  const visibleEnd = Math.min(visibleEndRaw, lastIndex)

  const hasHiddenBefore = visibleStart > 0
  const hasHiddenAfter = visibleEnd < lastIndex

  const isFirstVisibleActive = activeIndex === visibleStart
  const isLastVisibleActive = activeIndex === visibleEnd

  if ((isFirstVisibleActive && hasHiddenBefore) || (isLastVisibleActive && hasHiddenAfter)) {
    updatePaginationVisibility(swiper)
  }
}
